import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    device: null,
    isFindHIDStatus: false,       // 一个标记，用于判断连接HID设备的弹窗是否打开
  },
  getters: {
  },
  mutations: {
    clearDevice(state) {
      if (state.device !== null) {
        state.device.close()
        state.device = null
      }
    },
    setDevices(state, device) {
      state.device = device
    },
    changeIsFindHIDStatus(state, status) {
      state.isFindHIDStatus = status
    }
  },
  actions: {
  }
})